import React from 'react'

interface TownHallIconProps {
  width?: number
  height?: number
  alt?: string
}

const TownHallIcon: React.FC<TownHallIconProps> = ({
  width = 21,
  height = 24,
  alt = 'Test tube icon',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
      aria-label={alt}
    >
      <mask
        id='mask0_1682_1201'
        width='30'
        height='30'
        x='0'
        y='0'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'luminance' }}
      >
        <path fill='#fff' d='M30 0H0v30h30z'></path>
      </mask>
      <g mask='url(#mask0_1682_1201)'>
        <path fill='#DFDFDF' d='M28.729 13.22h-7.627v15.254h7.627z'></path>
        <path fill='#B9B9B9' d='M21.229 13.729h7.452l1.064-2.034H21.23z'></path>
        <path fill='#DFDFDF' d='M8.899 13.22H1.27v15.254H8.9z'></path>
        <path fill='#B9B9B9' d='M9.406 13.729H1.271L.254 11.695h9.152z'></path>
        <path fill='#CACACA' d='M21.61 6.102H8.39v22.373h13.22z'></path>
        <path
          fill='#B9B9B9'
          d='M15 5.085a.51.51 0 0 1-.508-.509V.508a.509.509 0 0 1 1.017 0v4.068c0 .281-.228.509-.508.509M17.034 5.085a.51.51 0 0 1-.509-.509V2.542a.509.509 0 0 1 1.017 0v2.034c0 .28-.228.509-.508.509M12.967 5.085a.51.51 0 0 1-.509-.509V2.542a.509.509 0 0 1 1.017 0v2.034c0 .28-.228.509-.508.509'
        ></path>
        <path
          fill='#B9B9B9'
          d='M21.61 6.61H8.39L7.373 4.576h15.254zM29.745 27.966H.254V30h29.491z'
        ></path>
        <path fill='#fff' d='M15 16.271a3.56 3.56 0 1 0 0-7.119 3.56 3.56 0 0 0 0 7.119'></path>
        <path
          fill='#0894CF'
          d='M15 13.22a.51.51 0 0 1-.509-.508v-1.526a.509.509 0 0 1 1.017 0v1.526c0 .28-.228.508-.508.508'
        ></path>
        <path
          fill='#0894CF'
          d='M16.017 13.22H15a.509.509 0 0 1 0-1.017h1.017a.509.509 0 0 1 0 1.017'
        ></path>
        <path fill='#DFDFDF' d='M18.05 21.864h-6.1v6.102h6.1z'></path>
        <path fill='#fff' d='M19.068 20.339h-8.135v1.525h8.135z'></path>
        <path
          fill='#DFDFDF'
          d='M15 18.305c-1.403 0-2.542.91-2.542 2.034h5.085c0-1.123-1.138-2.034-2.543-2.034'
        ></path>
        <path
          fill='#fff'
          d='M16.017 25.424H15a.509.509 0 0 1 0-1.017h1.017a.509.509 0 0 1 0 1.017'
        ></path>
        <path fill='#78D7FF' d='M6.356 15.763H3.305v10.17h3.05z'></path>
        <path
          fill='#0894CF'
          d='M6.356 17.796H3.305v1.017h3.05zM6.356 22.88H3.305v1.018h3.05zM6.356 20.339H3.305v1.017h3.05z'
        ></path>
        <path fill='#78D7FF' d='M26.695 15.763h-3.05v10.17h3.05z'></path>
        <path
          fill='#0894CF'
          d='M26.695 17.796h-3.05v1.017h3.05zM26.695 22.88h-3.05v1.018h3.05zM26.695 20.339h-3.05v1.017h3.05z'
        ></path>
      </g>
    </svg>
  )
}

export default TownHallIcon
